import { render, staticRenderFns } from "./LoggedIssuesBody.vue?vue&type=template&id=e70157ee&scoped=true&"
import script from "./LoggedIssuesBody.vue?vue&type=script&lang=js&"
export * from "./LoggedIssuesBody.vue?vue&type=script&lang=js&"
import style0 from "./LoggedIssuesBody.vue?vue&type=style&index=0&id=e70157ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70157ee",
  null
  
)

export default component.exports